import { mockPromoService } from "./mockPromoService";

const useMock = true;

const impl = mockPromoService;

export const promoService = {
  getRecommendedPlan: (...args) => impl.getRecommendedPlan(...args),
  getSavedScenarios: (...args) => impl.getSavedScenarios(...args),
  getScenarioById: (...args) => impl.getScenarioById(...args),
  getPlanForSavedScenario: (...args) => impl.getPlanForSavedScenario(...args),
  simulatePromo: (...args) => impl.simulatePromo(...args),
};

